/**
 * API for Trusted Seller Stats
 */

import { URLS } from '@/constants';
import { CertifiedSellerData } from '@/services/api/models/certifiedSeller';

import session from '../session';

/**
 * Fetches Trusted Seller data for a given Company.
 */
export const getStats = async () => {
  const response = await session.get<CertifiedSellerData>(`${URLS.COMPANY.TRUSTED_SELLER}/`);

  return response.data;
};
